import { BugReport } from './bug-report';

export enum EpicStatus {
  PLANNING = 'Planning',
  IN_PROGRESS = 'In behandeling',
  COMPLETED = 'Afgerond',
  ON_HOLD = 'On hold'
}

export interface Epic {
  id: number;
  title: string;
  description: string | null;
  startDate: string | null;
  endDate: string | null;
  status: EpicStatus;
  ownerId: string | null;
  features: BugReport[];
  createdAt: string;
  updatedAt: string;
}

export interface EpicProgress {
  total: number;
  reported: number;
  inProgress: number;
  testing: number;
  resolved: number;
  closed: number;
  percentComplete: number;
}

export interface EpicRoadmapData {
  epic: Epic;
  progress: EpicProgress;
}
